import { useContext, useEffect, useState } from 'react';
import { useOutletContext, useParams } from 'react-router-dom';
import CreateScannedDoc from '..';
import { MainContext } from '../../../../../../context/MainContext';
import { getLaboratory } from '../../../../../../services/api/laboratory';
import { createScannedDocument } from '../../../../../../services/api/scannedDocuments';
import { getProjectTemplateById } from '../../../../../../services/api/projectTemplates';
import { FORMSATTR, VALIDABLE_FALSE } from './formItems';

const CreateLaboratoryScannedDoc = () => {
  const { setLoading } = useContext(MainContext);
  const { project } = useOutletContext();

  const { templateId } = useParams();
  const [initialData, setInitialData] = useState(null);
  const [templateReaded, setTemplate] = useState(null);

  const newValidatedScannedDoc = async (regions, formState, fileName) => {
    await createScannedDocument(
      {
        fileName,
        template: templateId,
        pid: project.id_project,
        docket_number: formState.docket_number,
        regions,
        laboratory_note_data: {
          ...formState,
        },
      },
      'laboratory',
    );

    return 'scannedDocCreated';
  };

  useEffect(() => {
    async function loadTemplate() {
      setLoading(true);
      const loadedTemplate = (await getProjectTemplateById({ id: templateId }))
        .data;
      const loadedLab = (await getLaboratory(loadedTemplate.labId)).data;

      setTemplate(loadedTemplate);
      setInitialData({
        form: {
          templateName: loadedTemplate.name,
          supplier_id: loadedTemplate.supplier,
          phone_number: loadedLab.phone_number,
          email: loadedLab.email,
        },
        regions: loadedTemplate.regions,
      });
    }
    loadTemplate();
  }, [setLoading, templateId]);

  return (
    <CreateScannedDoc
      formsAttr={FORMSATTR}
      closeForm={newValidatedScannedDoc}
      model="laboratory"
      initialData={initialData}
      validable={VALIDABLE_FALSE}
      loadedTemplate={templateReaded}
    />
  );
};

export default CreateLaboratoryScannedDoc;
